<template>
    <div class="container mt-40 ">
        <div class="row">
            <div class="col-lg-8">
                <!-- Tab Navigation -->
                <div class="event-tabs d-flex" :class="{ fixedTabs: isFixed }" :style="fixedTabsStyle">
                    <div>
                        <a href="#" :class="['fw-600', 'text-16', 'text-secondary', 'capitalize', { active: activeTab === 'overview' }]"
                            @click.prevent="setActiveTab('overview')">
                            {{ $t('tabs.overview') }}
                        </a>
                    </div>
                    <div>
                        <a href="#" :class="['fw-600', 'text-16', 'text-secondary', 'capitalize', { active: activeTab === 'curriculum' }]"
                            @click.prevent="setActiveTab('curriculum')">
                            {{ $t('tabs.curriculum') }}
                        </a>
                    </div>
                    <div>
                        <a href="#" :class="['fw-600', 'text-16', 'text-secondary', 'capitalize', { active: activeTab === 'timing' }]"
                            v-if="courseItem?.course_type === 'INTERACTIVE_SESSION'"
                            @click.prevent="setActiveTab('timing')">
                            {{ $t('curriculum.title2') }}
                        </a>
                    </div>
                    <div v-if="courseItem?.enrollment['is_enrolled'] && courseItem?.options['has_certification']">
                        <a href="#" :class="['fw-600', 'text-16', 'text-secondary', 'capitalize', { active: activeTab === 'certification' }]"
                            @click.prevent="setActiveTab('certification')">
                            {{ $t('tabs.certification') }}
                        </a>
                    </div>
                    <div>
                        <a href="#" :class="['fw-600', 'text-16', 'text-secondary', 'capitalize', { active: activeTab === 'reviews' }]"
                            @click.prevent="setActiveTab('reviews')">
                            {{ $t('tabs.reviews') }}
                        </a>
                    </div>
                    <div v-if="courseItem?.enrollment['is_enrolled']">
                        <a href="#" :class="['fw-600', 'text-16', 'text-secondary', 'capitalize', { active: activeTab === 'question' }]"
                            @click.prevent="setActiveTab('question')">
                            {{ $t('tabs.question') }}
                        </a>
                    </div>
                </div>

                <!-- Tab Content -->
                <div id="overview" class="pt-60 overflow-hidden to-over">
                    <Overview />
                </div>

                <div id="certification" class="pt-90 lg:pt-60 to-over" v-if="courseItem?.enrollment['is_enrolled'] && courseItem?.options['has_certification']">
                    <Certification />
                </div>

                <div id="curriculum" class="pt-90 lg:pt-90 to-over">
                    <Curriclum />
                </div>

                <div id="timing" class="pt-90 lg:pt-60 to-over"
                    v-if="courseItem?.course_type === 'INTERACTIVE_SESSION'">
                    <Schaduals />
                </div>
                <div id="reviews" class="pt-90 lg:pt-60 to-over">
                    <Reviews />
                </div>

                <div id="question" class="pt-90 lg:pt-60 to-over" v-if="courseItem?.enrollment['is_enrolled']">
                    <Questions />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Overview from './Overview.vue';
import Curriclum from './Curriclum.vue';
import Certification from './Certification.vue';
import Reviews from './Reviews.vue';
import Questions from './Questions.vue';
import Schaduals from './Schaduals.vue';
import GlobalMixin from "@/Mixins/GlobalMixin";
export default {
    mixins: [GlobalMixin],
    components: {
        Overview,
        Reviews,
        Curriclum,
        Certification,
        Questions,
        Schaduals
    },
    data() {
        return {
            activeTab: "overview", // Default active tab
            isFixed: false,
        };
    },
    computed: {
        fixedTabsStyle() {
            if (this.isFixed) {
            return { top: this.activePromotion ? "200px" : "100px", position: "fixed", width: "100%", zIndex: "1000" };
            }
            return {}; // No fixed position when isFixed is false
        },
        courseItem() {
            return this.$store.getters.courseItem;
        },
    },
    methods: {
    setActiveTab(tabId) {
        this.activeTab = tabId; // Set the active tab
        const targetSection = document.getElementById(tabId); // Find the section by ID
        if (targetSection) {
            const offset = this.isFixed ? this.$el.querySelector(".event-tabs").offsetHeight : 100;
            const sectionTop = targetSection.getBoundingClientRect().top + window.scrollY - offset;

            window.scrollTo({
                top: sectionTop,
                behavior: "smooth", // Smooth scrolling
            });
        }
    },
    handleScroll() {
        const eventTabs = this.$el.querySelector(".event-tabs");
        const offsetTop = eventTabs.offsetTop;
        const scrollTop = window.scrollY;
        this.isFixed = scrollTop >= offsetTop;
    },
},
mounted() {
    window.addEventListener("scroll", this.handleScroll);
},
beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
},

}
</script>
<style lang="scss" scoped>
.event-tabs {
    gap: 24px;
    position: static;
    transition: .2s ease-in-out;
    a {
        font-weight: 600 !important;
        font-size: 20px !important;
        padding: 10px 0;

        &.active {
            border-bottom: 2px solid #ACBF00;
        }
    }
}

.fixedTabs {
    position: fixed;
  //  top: 100px;
    z-index: 87;
    padding: 30px 20px;
    background: #fff;
    width: 57%;
}
.to-over {
   scroll-margin-top: 100px; /* Adjust this value if needed */
}
</style>